import { ChangeDetectorRef, Component, ElementRef, Input, model, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { CommonConstants } from '@shared/constants';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { BaseSharedState } from 'src/app/shared-resources/store/base.state';
import { Store } from '@ngxs/store';
import { TariffService } from '@shared-services/tariff.service';
import { RDMClientService } from 'src/app/shared-resources/services/rdm-client.service';

@Component({
  selector: 'app-selection-dialog',
  templateUrl: './selection-dialog.component.html',
  styleUrls: ['./selection-dialog.component.less']
})
export class SelectionDialogComponent implements OnInit {
  @Input() isMultiple = false;
  @Input() selectedValues: any[] = [];
  @Input() refTypeCode = '';

  searchText = '';
  selectText = '';
  chapterSearch: string[] = [];
  chapterCodeList: any[] = [];
  hsCodeSearch = '';
  descriptionSearch = '';
  radioSelactionValue = 'Search';
  filteredData: any[] = [];
  selectedValue: string = '';
  showFlags = false;
  flagPath = CommonConstants.countryFlagPath;
  loading = false;
  pageIndex = 0;
  pageSize = 10;
  total = 0;
  allChecked = false;
  indeterminate = false;
  favouriteList: any[] = [];
  selectedFavourite: any;
  public rdmData$ = new BehaviorSubject<any>(null);
  rdmData: any = null;
  maxPages: any = 0;
  gotoPageNumber: number | null = null;
  favlistIds: any= null;
  isFavouriteMode =false;
  controlType: string = '';
  isPair: boolean = false;
  hscodeMappingData: any;
  module: any = '';
  isAlterMode: boolean = false;

  constructor(private modalRef: NzModalRef,
    private http: HttpClient,
    private store: Store,
    private cdr: ChangeDetectorRef,
    private tariffService: TariffService,
    private rdmClient: RDMClientService,
    private el: ElementRef
  ) { }


  async ngOnInit(): Promise<void> {
      const modalData = this.modalRef.getConfig().nzData;
      if (modalData) {
        this.isMultiple = modalData.isMultiple;
        this.selectedValues = modalData.selectedValues || [];
        this.refTypeCode = modalData.refTypeCode;
        this.radioSelactionValue = modalData.radioSelactionValue;
        this.favlistIds = +modalData.favlistIds;
        this.controlType = modalData.controlType || '';
        this.isPair = modalData.isPair || false;
        this.hscodeMappingData = modalData?.hscodeMappingData || null;
        this.module = modalData?.module || '';
        this.chapterSearch = modalData?.selectedChapterCodes || [];
        this.isAlterMode = modalData?.isAlterMode || false;
        if (this.favlistIds) {
          this.isFavouriteMode = true;
        }
      }
      await this.initStoreData();
      this.showFlags = ['tred8453', 'tred3207'].includes(this.refTypeCode);
      if (!this.isPair) {
        if (this.isMultiple) {
         this.loadFavouriteList() 
        }
      }
      this.controlType?.toLowerCase() === 'hscode' ? this.findHsCode() : await this.loadData();

      if (!this.isMultiple && this.selectedValues.length > 0) {
        this.selectedValue = this.selectedValues[0].code;
      }
  }

  loadData(): void {
    this.loading = true;
    const url = `${environment.baseUrl}/rdm/api/v1/values/search/filter?page=${this.pageIndex - 1}&size=${this.pageSize}&refTypeLabel=${this.refTypeCode}&label=${this.searchText}`;
    this.http.get<any>(url).subscribe({
        next: (response) => {
            this.filteredData = (response.content || []).map((item: any) => ({
              ...item,
              checked: this.selectedValues.some( selected => selected.code === item.code)
        }));
        this.total = response.totalElements || 0;
        this.maxPages = response.totalPages || 0;
        this.updateSelectAllStatus();
          this.loading = false;
        },
        error: () => {
          this.filteredData = [];
          this.total = 0;
          this.maxPages = 0;
          this.loading = false;
        }
    });
  }

  onSearch(): void {
    this.pageIndex = 0;
    this.controlType?.toLowerCase() === 'hscode' ?  this.findHsCode() : this.loadData();
  }

  onPageChange(page: number) {
    this.pageIndex = page;
    this.controlType?.toLowerCase() === 'hscode' ? this.findHsCode() : this.loadData();
  }

  refreshStatus(checked: boolean, item: any): void {
    item.checked = checked;
    if (checked) {
      if (!this.selectedValues.some(s => s.code === item.code)) {
        this.selectedValues.push({ code: item.code, label: item.label });
      }
    } else {
      //this.selectedValues = this.selectedValues.filter(selected => selected.code !== item.code && selected.label !== item.label);
      this.selectedValues = this.selectedValues.filter(selected => selected.code !== item.code);
    }
    this.updateSelectAllStatus();
  }

  checkAll(checked: boolean): void {
    this.filteredData.forEach(item => {
      item.checked = checked;
      if (checked) {
        if (!this.selectedValues.some(s => s.code === item.code)) {
          this.selectedValues.push({ code: item.code, label: item.label });
        }
      } else {
        this.selectedValues = this.selectedValues.filter(selected => selected.code !== item.code);
      }
    });
    this.updateSelectAllStatus();
  }

  updateSelectAllStatus(): void {
    const checkedCount = this.filteredData.filter(item => item.checked).length;
    this.allChecked = checkedCount === this.filteredData.length && this.filteredData.length > 0;
    this.indeterminate = checkedCount > 0 && checkedCount < this.filteredData.length;
  }

  onRadioChange(item: any): void {
    this.selectedValue = item.code;
    this.selectedValues = [this.isAlterMode ? { ...item } : { code: item.code, label: item.label }];
  }

  confirmSelection(): void {
    if (this.isMultiple) {
      if (this.selectedFavourite) {
        // When selecting from favorite list
          const codes = this.selectedValues.filter(item => item.code).map(item => item.code).join(',');
          const labels = this.selectedValues.filter(item => item.label).map(item => item.label).join(', ');
          const radioSelactionValue = this.radioSelactionValue;
          this.modalRef.close({ codes, labels, radioSelactionValue, favlistIds: this.favlistIds, chapterCodes: this.chapterSearch });
      } else {
        // When selecting from search
        const codes = this.selectedValues.filter(item => item.code).map(item => item.code).join(',');
        const labels = this.selectedValues.filter(item => item.label).map(item => item.label).join(', ');
        const radioSelactionValue = this.radioSelactionValue;
        this.modalRef.close({ codes, labels, radioSelactionValue, favlistIds: null, chapterCodes: this.chapterSearch, isAlterMode: this.isAlterMode ? this.selectedValues : ''});
      }
    } else {
      if (!this.selectedValue) {
        this.modalRef.close();
        return;
      }
      const selectedItem = this.filteredData.find(item => item.code === this.selectedValue) || this.selectedValues[0];
      const label = selectedItem?.label || this.selectedValue;
      this.modalRef.close({ codes: this.selectedValue, labels: label, radioSelactionValue: this.radioSelactionValue, selectedHscode: this.isAlterMode ? selectedItem : '' });
    }
  }

  goBack(): void {
    this.modalRef.close({ goBack: true });
  }

  loadFavouriteList(): void {
    this.loading = true;
    const url = `${environment.baseUrl}/intelligenceman/api/v1/favouriteList/search?masterData=${this.refTypeCode}&status=ACTIVE`;
    this.http.get<any>(url).subscribe({
      next: (response) => {
        this.favouriteList = response?.favouriteListDto?.content;
        this.favouriteList.map((fav: any) => {
          fav.checked = false;
          fav?.favouriteListData?.map((data: any) => {
            let rdmData: any = null;
            for (const [key, value] of this.rdmData) {
              const found = value?.find((rdm: any) => rdm.code == data.code);
              if (found) {
                rdmData = found;
                break;
              }
            }
            if (rdmData) {
              data.label = rdmData?.label;
            }
          });
        });
        this.loading = false;

       if (this.favlistIds) {
          const foundFav = this.favouriteList?.find((fav: any) => +fav.id === this.favlistIds);
          if (foundFav) {
            foundFav.checked = true;
            this.selectedFavourite = foundFav;
          }
          this.updateSelectAllStatus();
          this.onFavouriteChange(foundFav)
        }
        if (this.selectedValues.length && this.radioSelactionValue == "Select") {

          this.favouriteList?.map((fav: any) => {
            let isDataAvailable: boolean = false;
            const checkedData = this.selectedValues?.find((value: any) => value?.code == fav?.favouriteListName);

            fav?.favouriteListData?.map((data: any) => {
              isDataAvailable = checkedData ? true : isDataAvailable;
              data.checked = checkedData ? true : false;
            });

            // if (isDataAvailable) {
            //   this.filteredData.push(...fav?.favouriteListData);
            //   this.selectedFavourite = fav;
            // }
          });

          //this.selectedFavourite = [...this.selectedFavourite];
          this.filteredData = [...this.filteredData];
        }

        this.total = this.filteredData?.length;
        this.allChecked = this.filteredData.every((x: any) => x.checked);
        this.indeterminate = (this.filteredData.some((x: any) => x.checked) && !this.allChecked);
      },
      error: () => {
        this.favouriteList = [];
      }
    });
  }

  favListCheckboxChange(favData: any, event: boolean) {
    if (event) {
      if (favData?.favouriteListData?.length) {
        favData?.favouriteListData?.map((data: any) => {
          data.checked = false;
          this.filteredData.push(data);
        });

        this.filteredData = [...this.filteredData];
        this.cdr.detectChanges();
      }
    } else {
      if (favData?.favouriteListData?.length) {
        const codesToRemove = favData.favouriteListData.map((d: any) => d.code);

        this.filteredData = this.filteredData.filter(
          (item: any) => !codesToRemove.includes(item.code)
        );

        this.cdr.detectChanges();
      }
    }
  }

  onFavouriteChange(selectedFav: any): void {
    this.selectedFavourite = selectedFav;
    this.favlistIds = selectedFav?.id || null;

    this.filteredData = [];
    this.selectedValues = [];

    if (selectedFav?.favouriteListData?.length) {
      selectedFav.favouriteListData.forEach((data: any) => {
        this.filteredData.push({
          ...data,
          checked: true   // auto-select
        });

        this.selectedValues.push({
          code: data.code,
          label: data.label
        });
      });
    }
  }
  
  async initStoreData() {
    try {
      const rdmKeys = ['kc_Ch_Code'];
      const storeRdmData: Map<string, any> = this.store.selectSnapshot(BaseSharedState.getRdmData);
      this.rdmData = storeRdmData;

      rdmKeys.forEach(key => {
        if (storeRdmData.has(key)) {
          this.assignRdmData(key, storeRdmData.get(key));
        }
      });

      const missingKeys = rdmKeys.filter(key => !storeRdmData.has(key));
      if (missingKeys.length > 0) {
        this.rdmClient.getAllRdmTypes(missingKeys, 'api').subscribe((res: any) => {
          if (res) {
            missingKeys.forEach(key => {
              const found = res?.find((r: any) => r.label === key);
              if (found) {
                storeRdmData.set(key, found.refValue);
                this.assignRdmData(key, found.refValue);
              }
            });
          }
        });
      }
    } catch (error) {
      console.error('Error loading RDM data:', error);
    }
  }

  private assignRdmData(key: string, data: any[]): void {
    switch (key) {
      case 'kc_Ch_Code': this.chapterCodeList = data || []; break;
    }
  }

  get selectAll() {
    return true
  }

  removeSelectedItem(item: any): void {
    this.selectedValues = this.selectedValues.filter(selected => selected.code !== item.code);
    const found = this.filteredData.find(d => d.code === item.code);
    if (found) {
      found.checked = false;
    }
    if (this.selectedFavourite) {
      this.selectedFavourite = null;
      this.favlistIds = null;
    }
    this.updateSelectAllStatus();
  }

  clearAllSelections(): void {
    this.selectedValues = [];
    this.selectedFavourite = null;
    this.favlistIds = null;
    this.filteredData.forEach(item => (item.checked = false));
    this.updateSelectAllStatus();
  }

  toggleItem(item: any): void {
    if (this.selectedFavourite) {
      this.selectedFavourite = null;
      this.favlistIds = null;
    }
    this.refreshStatus(!item.checked, item);
  }

  onPageSizeChange(size: number): void {
    this.pageSize = size;
    this.pageIndex = 0;
    this.controlType?.toLowerCase() === 'hscode' ? this.findHsCode() : this.loadData();
  }

  goToPage(): void {
    if (this.gotoPageNumber && this.gotoPageNumber >= 1 && this.gotoPageNumber <= this.maxPages) {
      this.pageIndex = this.gotoPageNumber;      
      this.controlType?.toLowerCase() === 'hscode' ? this.findHsCode() : this.loadData();
      this.gotoPageNumber = null;
    }
  }

  checkUncheckFav() {
    if (this.isFavouriteMode) {
      this.filteredData = [];
      this.selectedValues = [];
    } else {
      this.selectedFavourite = null;
      this.favlistIds = null;
      this.controlType?.toLowerCase() === 'hscode' ? this.findHsCode() : this.loadData();
    }
  }

  findHsCode(): void {
    if (this.hscodeMappingData?.mappingId) {
            this.hscodeMapping();
    } else {
      this.loading = true;
      const hsCodeParam = this.hsCodeSearch || '';
      const descParam = this.descriptionSearch || '';
      const chapterParam = this.chapterSearch?.join(',') || '';
      this.tariffService.getCommodityHSCode(hsCodeParam, descParam, '', this.pageSize, this.pageIndex - 1, chapterParam).subscribe({
        next: (response: any) => {
          this.filteredData = response.tariffSearchDto.content.map((item: any) => ({
            ...(this.isAlterMode ? item : {}),
            code: item.tariffCode,
            label: `${item.description || item?.descriptionInEnglish}`,
            uom: item.uom,
            checked: this.selectedValues.some(selected => selected?.code === item?.tariffCode)
          }));

  
          this.total = response.tariffSearchDto.totalElements || 0;
          this.maxPages = response.tariffSearchDto.totalPages || 0;
          this.updateSelectAllStatus();
          this.loading = false;
        },
        error: () => {
          this.filteredData = [];
          this.loading = false;
        }
      });
    }
  }

  hscodeMapping() {
   this.loading = true;
   const mappingId = this.hscodeMappingData?.mappingId;
   
   if (!mappingId) {
     this.loading = false;
     return;
   }

   this.tariffService.getHsCodesByMappingId(mappingId, this.pageIndex - 1, this.pageSize, this.chapterSearch?.join(',') || this.hsCodeSearch).subscribe({
      next: (response:any) => {
        this.filteredData = (response.content?.content || []).map((item: any) => ({
          ...(this.isAlterMode ? item : {}),
          code: item.hsCode,
          label: item.description,
          uom: item.uom,
          checked: this.selectedValues.some(selected => selected.code === item.hsCode)
        }));
        this.total = response.content?.totalElements || 0;
        this.maxPages = response.content?.totalPages || 0;
        this.updateSelectAllStatus();
        this.loading = false;
      },
      error: () => {
        this.filteredData = [];
        this.total = 0;
        this.maxPages = 0;
        this.loading = false;
      }
    }); 
  }

  closeModal() {
    this.modalRef.close();
  }

  numberOnly(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onHsSearchReset(): void {
    this.chapterSearch = [];
    this.hsCodeSearch = '';
    this.descriptionSearch = '';
    this.pageIndex = 0;
    this.findHsCode();
  }

  get hasHsSearchValue(): boolean {
    return !!(this.chapterSearch?.length || this.hsCodeSearch || this.descriptionSearch);
  }

}